<template>
  <div class="profile" v-if="serviceProfile">
    <div class="i_n">
      <div class="image">
        <img
          v-if="serviceProfile.profileImage"
          v-imageLoading="serviceProfile.profileImage.url"
        />
        <img v-else src="@/assets/images/common/Profile-icon.png" />
      </div>
      <div class="name">
        <div class="deco">Booking With</div>
        <div class="pname">
          {{ serviceProfile.name }}
          {{ serviceProfile.firstName }}
        </div>
      </div>
    </div>
    <div class="infos">
      <ul>
        <li class="item-k">PRICE</li>
        <li class="item-v">
          <span v-currency="serviceDetail.currencyUnit"></span>
          {{ serviceDetail.price }} / hours
        </li>
        <li class="item-k">Experience</li>
        <li class="item-v">{{ serviceProfile.experience }} years</li>
        <li class="item-k">Review</li>
        <li class="item-v" v-if="serviceDetail.rating">{{ grade }}</li>
        <li class="item-v" v-else>0.0</li>
        <li class="item-k">Languages</li>
        <li class="item-v" v-if="serviceDetail">
          {{ serviceDetail.languages.join() }}
        </li>
        <li class="item-v" v-else>English</li>
      </ul>
    </div>
    <div class="social">
      <img
        src="../../assets/images/social_icon/facebook.svg"
        class="facebook"
      />
      <img
        src="../../assets/images/social_icon/instagram.svg"
        class="instagram"
      />
      <img src="../../assets/images/social_icon/twitter.svg" class="twitter" />
    </div>
    <div class="contact" v-if="serviceProfile.saved">
      <button type="button" class="button save" @click="save">
        {{ serviceProfile.saved.length > 0 ? 'UNSAVE' : 'SAVE IT FOR LATER' }}
      </button>
      <button type="button" @click="requestToNext" class="button request">
        REQUEST TO BOOK
      </button>
    </div>
  </div>
</template>

<script>
import * as types from '../../store/mutation-types'
import { mapGetters } from 'vuex'
import mixinPrice from '../../mixin/price'
import { saved } from '../../api/saved'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixinPrice, mixCommon],
  name: 'profile',
  data() {
    return {
      checkSaved: false
    }
  },
  created() {},
  mounted() {
    console.log('service detail:', this.serviceProfile)
  },
  methods: {
    save() {
      if (this.userInfo.uid) {
        saved(this.serviceDetail.id, this.userInfo.uid).then(resText => {
          this.$store
            .dispatch(types.SET_MODAL_ALERT_FOOTER, {
              active: true,
              text: resText,
              propData: {}
            })
            .then(() => {
              this.$store
                .dispatch(types.GET_SERVICE_DETAIL, {
                  serviceId: this.serviceDetail.id,
                  uid: this.userInfo.uid
                })
                .then(() => {
                  setTimeout(() => {
                    console.log(resText)
                    this.$store.commit(types.SET_MODAL_ALERT_FOOTER, {
                      active: false,
                      text: '',
                      propData: {}
                    })
                  }, 1000)
                })
            })
        })
      } else {
        alert('Need to login')
      }
    },
    requestToNext() {
      this.$store.dispatch(types.CHECK_LOGIN).then(r => {
        if (r && this.userInfo.type === 'user') {
          if (!this.userInfo.profileImage) {
            alert('Setup your profile image.')
            this.$store.dispatch(types.SET_MODAL_COMPONENT, {
              component: '',
              active: false,
              type: ''
            })
            this.$router.push({ path: '/user/account' })
          } else {
            this.$store.dispatch(types.SET_MODAL_COMPONENT, {
              component: 'requestPage',
              active: true,
              type: 'full',
              propData: {
                serviceId: this.serviceDetail.id
              }
            })
          }
        } else {
          alert('YOU NEED TO SIGN IN.')
          this.$store.dispatch(types.SET_MODAL_COMPONENT, {
            component: 'login',
            active: true,
            type: 'full'
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['serviceProfile', 'serviceDetail', 'userInfo']),
    grade() {
      // console.log(
      //     "this.data.rating:",
      //     this.serviceDetail.rating.toString().length
      // );
      return this.serviceDetail.rating.toString().length < 2
        ? this.serviceDetail.rating + '.0'
        : this.serviceDetail.rating
    }
  },
  directives: {
    language: {
      bind(el, binding, vnode) {
        // console.log(el, binding, vnode)
        if (!binding.value) return
        vnode.elm.innerText = binding.value
          .reduce((acc, ccc) => {
            switch (ccc) {
              case 'English':
                return (acc += ',EN')
              case '한국어':
                return (acc += ',KR')
              case 'German':
                return (acc += ',GR')
              case 'French':
                return (acc += ',FR')
              case '日本語':
                return (acc += ',JN')
              case '中國語':
                return (acc += ',CN')
            }
          }, '')
          .replace(',', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  width: 95%;
  position: relative;

  .i_n {
    .image {
      position: absolute;
      left: 0;
      top: 0;

      img {
        object-fit: cover;
        width: 75px;
        height: 75px;
      }
    }

    .name {
      margin: 0 0 0 85px;
      height: 75px;

      .deco {
        font-family: Poppins;
        font-size: 17px;
        font-weight: 300;
        color: #000;
        margin: 3px 0 0 0;
      }

      .pname {
        font-family: Poppins;
        font-size: 17px;
        font-weight: 600;
        color: #000;
        margin: 3px 0 0 0;
      }
    }
  }

  .infos {
    position: relative;
    margin: 24px 0 0 38px;

    ul {
      margin: 0;
      padding: 0;

      li {
        padding: 6px;
        list-style: none;
        font-family: Poppins;
        font-size: 15px;
        letter-spacing: 1px;

        &.item-k {
          font-weight: 600;
        }

        &.item-v {
          margin: 3px 0 17px 0;
          font-weight: 300;
        }
      }
    }
  }

  .social {
    visibility: hidden;
    position: absolute;
    left: 38px;
    bottom: 330px;
    right: 160px;
    z-index: 10;
    width: 150px;
    height: 50px;

    .facebook {
      position: absolute;
      right: 100px;
      width: 50px;
      height: 50px;
    }

    .twitter {
      position: absolute;
      right: 50px;
      width: 50px;
      height: 50px;
    }

    .instagram {
      position: absolute;
      right: 0;
      width: 50px;
      height: 50px;
    }
  }

  .contact {
    position: absolute;
    left: 38px;
    bottom: 100px;

    button {
      width: 200px;
      height: 50px;
      border: solid 1px #dddddd;
      border-radius: 2px;
      background-color: #000bff;
      outline: none;
      color: #fff;
      letter-spacing: 1px;
      font-size: 14px;
      cursor: pointer;

      &.save {
        background-color: #fff;
        color: #000;
        font-weight: 300;
      }

      &.request {
        font-weight: 600;
        margin: 10px 0 0 0;
        border: 1px solid #000bff;
      }
    }
  }
}
</style>
